if (!customElements.get('pdp-video-slide')) {
  class PdpVideoSlide extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.textItems = this.querySelectorAll('.pdp-video-slide__text-item');
      this.mediaItems = this.querySelectorAll('.pdp-video-slide__media-item');
      this.mobileTitle = this.querySelector('.pdp-video-slide__mobile-title');
      this.mobileDesc = this.querySelector('.pdp-video-slide__mobile-desc');
      this.navCurrent = this.querySelector('.pdp-video-slide__nav-current');
      this.totalSlides = this.mediaItems.length;
      this.isTw = false;
    }

    connectedCallback() {
      this.detectTw();
      this.bindEvents();

      // Weglot may initialize after DOM ready
      if (window.Weglot && typeof Weglot.on === 'function') {
        Weglot.on('languageChanged', () => {
          this.detectTw();
        });
      }
    }

    detectTw() {
      let lang = '';
      if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
        lang = Weglot.getCurrentLang();
      }
      if (!lang || lang === 'en') {
        lang = document.documentElement.lang || '';
      }
      if (!lang || lang === 'en') {
        const path = window.location.pathname.toLowerCase();
        const match = path.match(/^\/(zh-tw|zh-cn|tw|zh)\//);
        if (match) lang = match[1];
      }
      lang = lang.toLowerCase();
      this.isTw = lang.startsWith('zh') || lang === 'tw';

      if (this.isTw) {
        this.textItems.forEach((item) => {
          const twTitle = item.dataset.titleTw;
          const twDesc = item.dataset.descTw;
          if (twTitle) item.querySelector('.pdp-video-slide__title').textContent = twTitle;
          if (twDesc) item.querySelector('.pdp-video-slide__desc').textContent = twDesc;
        });
        this.updateMobileText(0);
      }
    }

    bindEvents() {
      this.textItems.forEach((item) => {
        item.addEventListener('click', () => {
          const idx = parseInt(item.dataset.index, 10);
          this.goTo(idx);
        });
      });

      const prevBtn = this.querySelector('[data-dir="prev"]');
      const nextBtn = this.querySelector('[data-dir="next"]');
      if (prevBtn) prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));

      this.bindSwipe();
    }

    bindSwipe() {
      const media = this.querySelector('.pdp-video-slide__media');
      if (!media) return;

      let startX = 0;
      let startY = 0;
      let tracking = false;

      media.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      media.addEventListener('touchmove', (e) => {
        if (!tracking) return;
        const dx = Math.abs(e.touches[0].clientX - startX);
        const dy = Math.abs(e.touches[0].clientY - startY);
        // If horizontal swipe is dominant, prevent vertical scroll
        if (dx > dy && dx > 10) {
          e.preventDefault();
        }
      }, { passive: false });

      media.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;
        const endX = e.changedTouches[0].clientX;
        const diff = endX - startX;
        const threshold = 40;
        if (Math.abs(diff) < threshold) return;

        if (diff < 0) {
          this.goTo(this.currentIndex + 1);
        } else {
          this.goTo(this.currentIndex - 1);
        }
      }, { passive: true });
    }

    goTo(index) {
      if (this.totalSlides === 0) return;

      // Wrap around
      if (index < 0) index = this.totalSlides - 1;
      if (index >= this.totalSlides) index = 0;

      if (index === this.currentIndex) return;

      // Pause old video, play new video
      const oldMedia = this.mediaItems[this.currentIndex];
      const newMedia = this.mediaItems[index];
      const oldVideo = oldMedia && oldMedia.querySelector('video');
      const newVideo = newMedia && newMedia.querySelector('video');

      if (oldVideo) oldVideo.pause();

      // Toggle active classes
      this.textItems.forEach((el) => el.classList.remove('is-active'));
      this.mediaItems.forEach((el) => el.classList.remove('is-active'));

      const targetText = this.textItems[index];
      if (targetText) targetText.classList.add('is-active');
      if (newMedia) newMedia.classList.add('is-active');

      if (newVideo) {
        newVideo.currentTime = 0;
        newVideo.play().catch(() => {});
      }

      this.currentIndex = index;

      // Update counter
      if (this.navCurrent) {
        this.navCurrent.textContent = index + 1;
      }

      // Update mobile text
      this.updateMobileText(index);
    }

    updateMobileText(index) {
      if (!this.mobileTitle || !this.mobileDesc) return;
      const item = this.textItems[index];
      if (!item) return;

      let title, desc;
      if (this.isTw) {
        title = item.dataset.titleTw || item.dataset.title;
        desc = item.dataset.descTw || item.dataset.desc;
      } else {
        title = item.dataset.title;
        desc = item.dataset.desc;
      }

      this.mobileTitle.textContent = title || '';
      this.mobileDesc.textContent = desc || '';
    }
  }

  customElements.define('pdp-video-slide', PdpVideoSlide);
}
